<!-- src/views/LoginView.vue -->
<template>
  <div class="login-view-container">
    <LoginDialog v-model="showLoginDialog" />
    
    <div class="content-container">
      <div class="welcome-section">
        <h1>Welcome to StARRS</h1>
        <p class="description">
          The Streaming Analysis of Radar Results Solution (StARRS) 
          is a platform for monitoring ground movement using satellite data.
        </p>
        
        <Button 
          v-if="!authStore.isAuthenticated" 
          label="Sign In" 
          class="login-button" 
          @click="showLoginDialog = true"
        />
        
        <div v-else class="authenticated-user">
          <p>You are currently logged in as <strong>{{ authStore.username }}</strong></p>
          <Button label="Logout" class="logout-button" @click="authStore.logout" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { ref } from 'vue'
import LoginDialog from '@/components/LoginDialog.vue'

const authStore = useAuthStore()
const showLoginDialog = ref(true)
</script>

<style scoped>
.login-view-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 80vh;
  padding: 2rem;
}

.content-container {
  max-width: 800px;
  width: 100%;
  text-align: center;
  margin-top: 2rem;
}

.welcome-section {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #333;
  margin-bottom: 1rem;
}

.description {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.login-button {
  margin-top: 1rem;
}

.authenticated-user {
  margin-top: 1rem;
}

.logout-button {
  margin-top: 1rem;
}
</style>
